import { Component, EventEmitter, inject, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AngularSvgIconModule } from "angular-svg-icon";
import { LoggerService } from "../../../ancestors/logger.service";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";

/**
 * Componente bottone di aiuto per l'header
 * Mostra un'icona di aiuto che apre la sidenav del supporto
 * Componente completamente indipendente e immutabile
 */
@Component({
  selector: "ape-header-help-button",
  standalone: true,
  imports: [
    CommonModule, AngularSvgIconModule, TranslatePipe
  ],
  templateUrl: "./ape-header-help-button.component.html"
})
export class ApeHeaderHelpButtonComponent {
  /**
   * Chiavi di traduzione per type safety
   */
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  private logger = inject(LoggerService);

  /**
   * Evento emesso quando il bottone viene cliccato per aprire il sidenav
   */
  @Output() openSupportSidenav = new EventEmitter<void>();

  constructor() {
    this.logger.setCaller(this.constructor.name);
  }

  /**
   * Gestisce il click sul bottone di aiuto
   * Emette un evento per aprire il sidenav del supporto
   */
  onHelpClick(): void {
    this.logger.info("Help button clicked - opening support sidenav");
    this.openSupportSidenav.emit();
  }
}
